"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerV2Service = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class CustomerV2Service {
    /**
     * Creates a payment method session for Stripe embedded payment management.
     * Returns client secret needed to initialize Stripe Elements for payment method collection.
     * @returns CreatePaymentMethodSessionResponse Payment method session created successfully
     * @throws ApiError
     */
    static createPaymentMethodSession() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v2/customers/payment-methods/session',
        });
    }
}
exports.CustomerV2Service = CustomerV2Service;
